import type { TechnicalObjectStatus } from '@oscom/shared';

/** German display labels for `TechnicalObjectStatus`. */
export const TECHNICAL_OBJECT_STATUS_LABELS: Record<TechnicalObjectStatus, string> = {
  planned: 'Geplant',
  confirmed: 'Bestätigt',
  clarificationPending: 'Klärung offen',
  installed: 'Installiert',
  removed: 'Entfernt',
  rejected: 'Abgelehnt',
};
